import React from 'react';
import { IFileThumbnail } from '../../types';
import { PictureThumbnail } from './PictureThumbnail';
import { DocumentThumbnail } from './DocumentThumbnail';
import { useFileOutputPreview } from '../../../../../utils/media-manager-sdk/hooks';
import { TranscodingStatus } from '../../../../../constants/TranscodingStatus';

export const DocumentWithPreviewThumbnail: React.FC<IFileThumbnail> = (props) => {
  const [previewStatus, _] = useFileOutputPreview(props.file);

  return !previewStatus || previewStatus === TranscodingStatus.Failed ? (
    <DocumentThumbnail {...props} />
  ) : (
    <PictureThumbnail {...props} />
  );
};
